import React, { ReactElement } from 'react';
import './fonticon/iconfont.css';
import classnames from 'classnames';
type iconProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    name?: string;
    className?: string | undefined;
};

const AbbIcon = (props: iconProps): ReactElement => {
    const { name, className, ...rest } = props;

    return <span className={classnames('iconfont', `icon-${name}`, className)} {...rest} />;
};

export default AbbIcon;
